import React, {useEffect} from 'react';
import { Redirect, Route, Switch, useLocation } from 'react-router-dom';
import RouteProvider from './RouteProvider';
import SiteLoader from './SiteLoader';

const PostRouteChangeToParent = () => {
    const location = useLocation();
    useEffect(() => {
        window.parent.postMessage({id: 'dmg-widget-route', route: location}, '*');
    }, [location]);

    return null;
};

const RouteGenerator = ({routes, routesWrapper: RoutesWrapper = ({children}) => children, isWidget}) => (
    <RouteProvider routes={routes}>
        {isWidget && <PostRouteChangeToParent />}
        <RoutesWrapper>
            <Switch>
                {Object.values(routes).map(({path, redirectTo, component}) => (
                    redirectTo
                        ? <Redirect key={path} exact from={path} to={redirectTo} />
                        : <Route key={path} exact path={path} component={component} />
                ))}

                {/* If no route matches, try to load the page from the backend */}
                <Route exact path="/:path+" render={props => (
                    <SiteLoader key={props.match.params.path} {...props} />
                )} />
            </Switch>
        </RoutesWrapper>
    </RouteProvider>
);

export default RouteGenerator;
